// Visitor's cookie consent choice (LGPD). Analytics only runs after "accepted".
// The storage key is also read by the analytics bootstrap in public/index.html.
export const CONSENT_KEY = "buzas_cookie_consent";
export const CONSENT_EVENT = "buzas:consent-change";

const notify = () => window.dispatchEvent(new Event(CONSENT_EVENT));

export const getConsent = () => window.localStorage.getItem(CONSENT_KEY);

export const setConsent = (choice) => {
  window.localStorage.setItem(CONSENT_KEY, choice);
  if (choice === "accepted") {
    window.buzasAnalytics?.enable();
  } else {
    window.buzasAnalytics?.disable();
  }
  notify();
};

export const resetConsent = () => {
  window.localStorage.removeItem(CONSENT_KEY);
  window.buzasAnalytics?.disable();
  notify();
};
